import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "",
    },
    tooltip: {
      titleFont: {
        family: "IRANSans",
        size: 12,
      },
      bodyFont: {
        family: "IRANSans",
        size: 10,
      },
      footerFont: {
        family: "IRANSans",
        size: 10,
      }
    },
    legend: {
      // rtl: true,
      labels: {
        font: {
          family: "IRANSans",
          size: 12,
        },
      },
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
      ticks: {
        font: {
          family: 'IRANSans',
          size: 12,
        },
      },
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      grid: {
        drawOnChartArea: true,
      },
      ticks: {
        font: {
          family: 'IRANSans',
          size: 12,
        },
      },
    },
    x: {
      ticks: {
        font: {
          family: 'IRANSans',
          size: 12,
        },
      },
    },
  },
};

/*export const data = {
  labels: ["فروردین", "اریبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر"],
  datasets: [
    {
      label: "در",
      data: [-937, -637, -368, -332, 766, -369, 956],
      borderColor: "#ec87bf",
      backgroundColor: "#ec87bf",
      yAxisID: "y",
    },
    {
      label: "پنجره",
      data: [835, 601, -555, 566, -680, 207, 351],
      borderColor: "#9398ec",
      backgroundColor: "#9398ec",
      yAxisID: "y1",
    },
  ],
};*/


function LineChart({data}) {
  return <Line
    options={options}
    data={data}
  />;
}

export default LineChart;
